import cn from 'classnames';
import React, { memo } from 'react';

import { Space, Typography } from '@sravni/react-design-system';
import { PartnerBadge } from '@sravni/react-ugc/lib/PartnerBadge';
import type { OFFERS_TYPE } from '@sravni/ugc/lib/specialOffers/types';

import { trimText } from '../../../../helpers/trim';
import type { Condition } from '../../../../hooks/useProductData';
import { IItem } from '../../../../interfaces/organizations';
import blockStyles from '../../product-block.module.scss';
import { Logo } from '../Logo';
import { RatingWithReviews } from '../RatingWithReviews';

import styles from './common.module.scss';

interface CommonProps {
  isMobile: boolean;
  type: OFFERS_TYPE;
  organization: IItem;
  bankName: string;
  ratingValue: number;
  isPartnerCard: boolean;
  itemId: string;
  conditions: Condition[];
  offerTitle: string;
  label: string;
  logoSrc: string;
  isCard: boolean;
}

export const CommonCard = memo(
  ({
    type,
    bankName,
    ratingValue,
    isPartnerCard,
    itemId,
    conditions,
    offerTitle,
    organization,
    isMobile,
    logoSrc,
    isCard,
  }: CommonProps) => (
    <Space size={20} align={isMobile ? 'start' : 'center'} direction={isMobile ? 'vertical' : 'horizontal'}>
      <Space size={16} className={blockStyles.infoBlock}>
        <div className={blockStyles.logo}>
          {isPartnerCard && (
            <PartnerBadge>
              <Logo logoSrc={logoSrc} isCard={isCard} type={type} />
            </PartnerBadge>
          )}
          {!isPartnerCard && <Logo logoSrc={logoSrc} isCard={isCard} type={type} />}
        </div>
        <div>
          <Space size={8} className={'h-mb-4'} align={'baseline'}>
            <Typography.Heading level={5} className={cn('h-color-D100', blockStyles.clampOneLine)}>
              {bankName}
            </Typography.Heading>
            <Typography.Text size={12} className={'h-color-D20'} nowrap>
              лиц. № {organization.license}
            </Typography.Text>
          </Space>
          <Space size={8} align={'center'}>
            {/*<Typography.Text size={10} uppercase nowrap className={'h-color-D60'}>*/}
            {/*  {label}*/}
            {/*</Typography.Text>*/}
            <Typography.Text
              className={'h-color-D60'}
              size={10}
              uppercase
              strong
              nowrap
              dangerouslySetInnerHTML={trimText(`«${offerTitle}»`, 24, true)}
            />
            <RatingWithReviews ratingValue={ratingValue} />
          </Space>
        </div>
      </Space>
      <Space size={16} wrap={isMobile}>
        {conditions?.length > 0 &&
          conditions.map(
            ({ value, description }) =>
              value && (
                <div key={`${type}-${itemId}-conditions-${value}`} className={styles.conditionsItem}>
                  <Typography.Text size={12} nowrap className="h-mb-4 h-color-D30">
                    {description}
                  </Typography.Text>
                  <Typography.Text size={16} nowrap strong className="h-color-D100">
                    {value}
                  </Typography.Text>
                </div>
              ),
          )}
      </Space>
    </Space>
  ),
);
